import {
  RDX_SESSION_UPDATE,
  RDX_SESSION_INIT,
  RDX_SESSION_INIT_DONE,
  RDX_SESSION_LOCALE_UPDATE,
  RDX_CUSTOMER_UPDATE,
  RDX_RESPONSE_UPDATE,
  RDX_HEADER_UPDATE,
  RDX_GROUP_CODE_UPDATE,
} from './sessionAction';

const initial = {
  locale: 'en-US',
  localeIntl: 'en-US',
  sessionId: 'NA',
  customerId: 'AU111111',
  header: {},
  responseId: '',
  groupCodes: [],
};

const session = (state = initial, action) => {
  let newState = Object.assign({}, state);
  switch (action.type) {
    case RDX_SESSION_UPDATE:
      newState = Object.assign({}, newState, action.jsonO);
      return newState;
    case RDX_CUSTOMER_UPDATE:
      newState = {...state, customerId: action.data, responseId: ''};
      return newState;
    case RDX_RESPONSE_UPDATE:
      newState = {...state, responseId: action.data};
      return newState;
    case RDX_HEADER_UPDATE:
      newState = {...state, header: action.data};
      return newState;
    case RDX_GROUP_CODE_UPDATE:
      newState = {...state, groupCodes: action.data};
      return newState;
    case RDX_SESSION_INIT:
      return state;
    case RDX_SESSION_INIT_DONE:
      return state;
    case RDX_SESSION_LOCALE_UPDATE:
      newState.localeIntl = action.localeIntl;
      newState.locale = newState.localeIntl.replace('-', '_');
      return newState;
    default:
      return state;
  }
};

export default session;
